import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useStore } from '@tanstack/react-store';
import { galleryStore } from '../store';
import { classNames } from '../tools/helpers';
import GallerySlider2 from './GallerySlider2';

export default function ImagePreview() {
    const dialogGallerySlider = useStore(galleryStore, (state) => state);

    const setDialogGallerySlider = (state) => {
        galleryStore.setState((prevState) => ({
            ...prevState,
            ...state,
        }));
    };
    return (
        <div
            className={classNames(
                'fixed inset-0 bg-apart-black-100 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in',
                !dialogGallerySlider.open && '!hidden',
            )}
        >
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
                    <div className="relative transform overflow-hidden rounded-lg pb-4 pt-5 text-left ransition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-[75%] lg:max-w-[50%] sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">
                        <div className="flex mb-5">
                            <button
                                type="button"
                                className="ml-auto inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                onClick={() => {
                                    setDialogGallerySlider({ open: false });
                                }}
                            >
                                <span className="sr-only">Close</span>
                                <XMarkIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                />
                            </button>
                        </div>
                        {/* Instead of GallerySlider2 we used inline image */}
                        <div className={'min-w-screen'}>
                            <GallerySlider2
                                images={dialogGallerySlider.images}
                                imageActive={dialogGallerySlider.imageActive}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
